import type * as React from 'react';
import { get } from '@Domain/Api';
import documentIndicatorsFetched, {
	type DocumentIndicatorsFetchedAction,
	type DocumentIndicatorsPayload,
} from '@Application/Indicators/Actions/documentIndicatorsFetched';
import documentIndicatorsFetchFailed, {
	type DocumentIndicatorsFetchFailedAction,
} from '@Application/Indicators/Actions/documentIndicatorsFetchFailed';
import resolveIndicatorBasePath from '@Application/Indicators/resolveIndicatorBasePath';
import type FetchDocumentIndicators from '@Application/Indicators/Queries/FetchDocumentIndicators';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';

type Actions = DocumentIndicatorsFetchedAction | DocumentIndicatorsFetchFailedAction;

type DocumentIndicatorsResponse = Omit<DocumentIndicatorsPayload, 'queryKey'>;

export default (query: FetchDocumentIndicators) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const response = await get<DocumentIndicatorsResponse>(
				`${resolveIndicatorBasePath(query.scope)}/documents?${query.toQueryString()}`,
			);

			const action = documentIndicatorsFetched({ ...response, queryKey: query.queryKey });
			dispatch(action);
			return action;
		} catch (error) {
			const action = documentIndicatorsFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
